import React from "react";
import ApprovDetailsItem from "./ApprovDetailsItem";
import approvDetailsLabels from "./ApprovDetailsLabels";
import "./ApprovDetails.css";
import { useTranslation } from "react-i18next";
import useApproPackings from "../../../../hooks/useApproPackings";
import { Spinner } from "react-bootstrap";

const ApprovDetailsList = ({ id }) => {
  const { packings, fetchNextPage, loading, hasMore } = useApproPackings(id);
  const { t } = useTranslation("common");
  return (
    <div className="w-100">
      <div className={`approvDetailsHeader row gx-0 bg-smoothBlue`}>
        {approvDetailsLabels?.map(({ label, className }, index) => (
          <p
            className={`${className} d-block mb-0 f14 py-3 alignH text-brightGrey sBold textNoWrap`}
            key={index}
          >
            {t(`${label}`)}
          </p>
        ))}
      </div>
      {/* Values */}
      <div className={`approvDetailsList bg-skyBlue`}>
        {packings?.map((packing) => {
          return (
            <ApprovDetailsItem key={packing.id} {...packing?.attributes} />
          );
        })}
        {hasMore && (
          <div className="py-2">
            {loading ? (
              <div className="text-center w-100 pt-3 pb-1">
                <Spinner size="sm" />
              </div>
            ) : (
              <div className="w-100 text-center">
                <button
                  className="text-brightGrey underline bg-transparent border-0  outline-none f14"
                  onClick={fetchNextPage}
                >
                  {t("See more")}
                </button>
              </div>
            )}
          </div>
        )}
        <hr
          style={{
            border: `1px solid white`,
            opacity: 0.8,
            width: "97%",
            margin: "auto",
          }}
        />
      </div>
    </div>
  );
};

export default ApprovDetailsList;
